import { render, staticRenderFns } from "./CodigoPromocional.vue?vue&type=template&id=2c8faa78"
import script from "./CodigoPromocional.vue?vue&type=script&lang=js"
export * from "./CodigoPromocional.vue?vue&type=script&lang=js"
import style0 from "./CodigoPromocional.vue?vue&type=style&index=0&id=2c8faa78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports